import { render, staticRenderFns } from "./planoDeMetas.vue?vue&type=template&id=c826814c&"
import script from "./planoDeMetas.vue?vue&type=script&lang=js&"
export * from "./planoDeMetas.vue?vue&type=script&lang=js&"
import style0 from "./planoDeMetas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports